import axios from 'axios';
import { Projet, ProjetDetail } from '../types';

const BASE = '/api/v1/paie/administration';

const unwrap = (r: { data: any }) => r.data?.data ?? r.data?.donnees ?? r.data;

export const administrationApi = {
  // Organisations
  obtenirOrganisation: () =>
    axios.get(`${BASE}/organisation/moi`).then(unwrap),

  listerProjetsOrganisation: (params?: { actif?: boolean }) =>
    axios.get<Projet[]>(`${BASE}/projets`, { params }).then(unwrap),

  // Projets
  listerProjets: (params?: { actif?: boolean }) =>
    axios.get<Projet[]>(`${BASE}/projets`, { params }).then(unwrap),

  obtenirProjet: (id: string) =>
    axios.get<ProjetDetail>(`${BASE}/projets/${id}`).then(unwrap),

  creerProjet: (data: Omit<Projet, 'idProjet' | 'actif'> & { idOrganisation: string }) =>
    axios.post<Projet>(`${BASE}/projets`, data).then(unwrap),

  modifierProjet: (id: string, data: Partial<Projet>) =>
    axios.put<Projet>(`${BASE}/projets/${id}`, data).then(unwrap),

  desactiverProjet: (id: string) =>
    axios.delete(`${BASE}/projets/${id}`).then(unwrap),

  reactiverProjet: (id: string) =>
    axios.patch(`${BASE}/projets/${id}/reactiver`).then(unwrap),

  affecterEmploye: (idProjet: string, data: { idEmploye: string; dateDebut: string }) =>
    axios.post(`${BASE}/projets/${idProjet}/affecter`, data).then(unwrap),

  retirerEmploye: (idProjet: string, idEmploye: string) =>
    axios.delete(`${BASE}/projets/${idProjet}/retirer/${idEmploye}`).then(unwrap),
};
